/* embla-dawn.js — Embla retrofit for Dawn product gallery (Erawell-style).
   Fallback-safe: if Embla never loads or selectors miss, Dawn's native gallery keeps working.
   Loads embla core (+autoplay) from local assets first, CDN fallback. */
(function () {
  var CDN_CORE = 'https://cdn.jsdelivr.net/npm/embla-carousel@8/embla-carousel.umd.js';
  var CDN_AUTO = 'https://cdn.jsdelivr.net/npm/embla-carousel-autoplay@8/embla-carousel-autoplay.umd.js';

  function injectBaseStyles() {
    if (document.getElementById('embla-dawn-styles')) return;
    var css =
      '[data-embla]{position:relative;}' +
      '[data-embla-viewport]{overflow:hidden;}' +
      '[data-embla-container]{display:flex;backface-visibility:hidden;touch-action:pan-y;}' +
      '[data-embla-dots]{display:flex;justify-content:center;align-items:center;gap:8px;flex-wrap:wrap;margin-top:14px;margin-bottom:4px;}' +
      '.embla__dot{appearance:none;-webkit-appearance:none;border:0;padding:0;margin:0;cursor:pointer;width:8px;height:8px;border-radius:50%;background:rgba(45,139,139,0.25);transition:width .25s ease,background .25s ease;flex-shrink:0;}' +
      '.embla__dot.is-selected{width:22px;border-radius:5px;background:#152B6F;}' +
      'media-gallery [data-embla-container].product__media-list{display:flex!important;flex-wrap:nowrap!important;overflow:visible!important;scroll-snap-type:none!important;}' +
      'media-gallery [data-embla-container] > .product__media-item{display:block!important;flex:0 0 100%!important;min-width:100%!important;max-width:100%!important;width:100%!important;scroll-snap-align:none!important;}' +
      'media-gallery.embla-on .slider-buttons,media-gallery.embla-on .slider-counter{display:none!important;}' +
      /* thumbnail strip: 4 visible at a time, horizontal scroll, mobile-visible */
      'media-gallery.embla-on .thumbnail-list{display:flex!important;flex-wrap:nowrap!important;overflow-x:auto!important;gap:8px!important;margin:12px 0 0!important;padding:2px 0!important;list-style:none!important;scrollbar-width:none;-webkit-overflow-scrolling:touch;scroll-behavior:smooth;}' +
      'media-gallery.embla-on .thumbnail-list::-webkit-scrollbar{display:none;}' +
      'media-gallery.embla-on .thumbnail-list__item{flex:0 0 calc(25% - 6px)!important;max-width:calc(25% - 6px)!important;width:calc(25% - 6px)!important;margin:0!important;}' +
      'media-gallery.embla-on .thumbnail-list__item .thumbnail{width:100%!important;aspect-ratio:1/1;border-radius:8px;overflow:hidden;opacity:.65;transition:opacity .2s,border-color .2s;border:2px solid transparent;}' +
      'media-gallery.embla-on .thumbnail-list__item .thumbnail img{width:100%;height:100%;object-fit:cover;}' +
      'media-gallery.embla-on .thumbnail-list__item.is-active-thumb .thumbnail{opacity:1;border-color:#152B6F;}';
    var s = document.createElement('style'); s.id = 'embla-dawn-styles'; s.textContent = css;
    document.head.appendChild(s);
  }
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (document.querySelector('script[data-embla-cdn="' + src + '"]')) { resolve(); return; }
      var s = document.createElement('script'); s.src = src; s.async = true; s.setAttribute('data-embla-cdn', src);
      s.onload = function () { resolve(); }; s.onerror = function () { reject(new Error('embla cdn fail')); };
      document.head.appendChild(s);
    });
  }
  function ready() { return typeof window.EmblaCarousel !== 'undefined'; }
  function hijack(el, fn) { el.addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); fn(e); }, { capture: true }); }

  function wrapAsEmbla(row, rootEl, opts) {
    if (rootEl.__emblaInit || row.__wrapped) return false;
    var viewport = document.createElement('div'); viewport.setAttribute('data-embla-viewport', '');
    row.parentNode.insertBefore(viewport, row); viewport.appendChild(row);
    row.setAttribute('data-embla-container', '');
    row.style.overflow = 'visible'; row.style.scrollSnapType = 'none'; row.__wrapped = true;
    rootEl.setAttribute('data-embla', '');
    rootEl.setAttribute('data-embla-loop', opts.loop ? 'true' : 'false');
    rootEl.setAttribute('data-embla-align', opts.align || 'center');
    return true;
  }
  function initOne(root) {
    if (root.__emblaInit) return;
    var viewport = root.querySelector('[data-embla-viewport]'); if (!viewport) return;
    root.__emblaInit = true;
    var loop = root.getAttribute('data-embla-loop') !== 'false';
    var align = root.getAttribute('data-embla-align') || 'center';
    var embla;
    try { embla = window.EmblaCarousel(viewport, { loop: loop, align: align, dragFree: false, containScroll: 'trimSnaps' }); }
    catch (e) { root.__emblaInit = false; return; }
    var dotsBox = root.querySelector('[data-embla-dots]');
    var dots = [];
    if (dotsBox) {
      embla.scrollSnapList().forEach(function (_, i) {
        var b = document.createElement('button'); b.setAttribute('data-embla-dot', ''); b.setAttribute('aria-label', 'Go to slide ' + (i + 1)); b.className = 'embla__dot'; dotsBox.appendChild(b);
      });
      dots = Array.prototype.slice.call(dotsBox.querySelectorAll('.embla__dot'));
      dots.forEach(function (d, idx) { d.addEventListener('click', function () { embla.scrollTo(idx); }); });
    }
    function selectDot() { var i = embla.selectedScrollSnap(); dots.forEach(function (d, idx) { d.classList.toggle('is-selected', idx === i); }); }
    embla.on('select', selectDot); embla.on('reInit', selectDot); selectDot();
    root.__embla = embla;
    root.querySelectorAll('img').forEach(function (img) { if (!img.complete) img.addEventListener('load', function () { try { embla.reInit(); } catch (e) {} }, { once: true }); });
  }

  function adaptGallery() {
    document.querySelectorAll('media-gallery').forEach(function (gal) {
      try {
        if (gal.__emblaInit) return;
        var row = gal.querySelector('.product__media-list'); if (!row) return;
        var slides = row.querySelectorAll('.product__media-item'); if (slides.length < 2) return;
        gal.classList.add('embla-on');
        var mainSlider = row.closest('slider-component');
        // kill Dawn's native scroll-slider so it can't fight Embla at phone widths (where slider--mobile turns on)
        row.classList.remove('slider', 'slider--mobile', 'slider--desktop', 'grid--peek');
        wrapAsEmbla(row, gal, { loop: true, align: 'center' });
        var viewport = gal.querySelector('[data-embla-viewport]');
        if (viewport && !gal.querySelector('[data-embla-dots]')) {
          var dotsBox = document.createElement('div'); dotsBox.setAttribute('data-embla-dots', '');
          viewport.insertAdjacentElement('afterend', dotsBox);
        }
        initOne(gal);
        var embla = gal.__embla; if (!embla) return;
        if (mainSlider) { var sb = mainSlider.querySelector('.slider-buttons'); if (sb) sb.style.display = 'none'; }
        // thumbnails sync (Dawn .thumbnail-list__item)
        var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.thumbnail-list__item'));
        thumbs.forEach(function (th, k) { var btn = th.querySelector('button') || th; hijack(btn, function () { embla.scrollTo(k); }); });
        function syncActive() {
          var i = embla.selectedScrollSnap();
          thumbs.forEach(function (th, k) { th.classList.toggle('is-active-thumb', k === i); var b = th.querySelector('button'); if (b) b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
          var at = thumbs[i];
          if (at) { var strip = at.parentElement; if (strip && strip.scrollWidth > strip.clientWidth + 4) { var left = at.offsetLeft - (strip.clientWidth / 2) + (at.offsetWidth / 2); try { strip.scrollTo({ left: left, behavior: 'smooth' }); } catch (e) { strip.scrollLeft = left; } } }
        }
        embla.on('select', syncActive); embla.on('reInit', syncActive); syncActive();
      } catch (e) {}
    });
  }

  function run() {
    injectBaseStyles();
    if (ready()) { adaptGallery(); return; }
    loadScript(CDN_CORE).then(function () { return loadScript(CDN_AUTO).catch(function () {}); }).then(function () { if (ready()) adaptGallery(); }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 60); });
})();
